import { render, staticRenderFns } from "./NonConformityCorrectiveActionForm.vue?vue&type=template&id=052bafc8&scoped=true&"
import script from "./NonConformityCorrectiveActionForm.vue?vue&type=script&lang=js&"
export * from "./NonConformityCorrectiveActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bafc8",
  null
  
)

export default component.exports